export function insertWordInFilename(filename: string, word: string) {
	const dotIndex = filename.lastIndexOf(".")
	if (dotIndex === -1) return filename + word

	const name = filename.substring(0, dotIndex)
	const extension = filename.substring(dotIndex)

	return `${name}${word}${extension}`
}
